import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CampaignAssociations, CampaignCreativeData, CampaignCreativeStatus, CreativeData, CreativePaymentStatus, CreativeStatusData, AdDurationData } from './creative-data';

const endpoints = {
    creativeStatus: '/v1/converged/brands/{brandId}/creativeStatus',
    creatives: '/v1/converged/brands/{brandId}/creatives/{creativeId}',
    campaignAssociations: '/v1/converged/campaigns/{campaignId}/creatives',
    creativeList: '/v1/converged/brands/{brandId}/brandcreatives',
    campaignCreativeStatus: '/v1/demand/campaigns/{campaignId}/creativeStatus',
    campaignCreatives: '/v1/converged/campaign/{campaignId}/creatives',
    creativePaymentStatus: '/v1/converged/payments?entity_type=MEDIA&entity_ids={entityIds}&offset={offset}&limit={limit}',
    adDurations: '/v1/converged/connections/{connectionId}/adDurations',
}

export const api = {
    getAllCreativeStatus: getAllCreativeStatus,
    getAllCreatives: getAllCreatives,
    createCreative: createCreative,
    getCreativeById: getCreativeById,
    updateCreative: updateCreative,
    assignCreativesToCampaign: assignCreativesToCampaign,
    getCampaignCreativeStatus: getCampaignCreativeStatus,
    getCampaignCreatives: getCampaignCreatives,
    getCreativesPaymentStatus: getCreativesPaymentStatus,
    getAdsDurations: getAdsDurations
};

function getAllCreativeStatus(http: HttpClient, brandId: number): Promise<Array<CreativeStatusData>> {
    let endpoint = environment.campaignUrl + endpoints.creativeStatus.replace('{brandId}', brandId.toString());
    return http.get(endpoint).toPromise().then(
        (response: Array<CreativeStatusData>) => {
            return response;
        }
    );
}

function getAllCreatives(http: HttpClient, brandId: number, creativeIds?: Array<number>): Promise<Array<CreativeData>> {
    let endpoint = environment.campaignUrl + endpoints.creativeList.replace('{brandId}', brandId.toString());
    if (creativeIds && creativeIds.length) {
        endpoint = endpoint + '?filter=' + creativeIds.join(',');
    }
    return http.get(endpoint).toPromise().then(
        (response: Array<CreativeData>) => {
            return response;
        }
    );
}

function createCreative(http: HttpClient, brandId: number, creatives: Array<CreativeData>): Promise<Array<CreativeData>> {
    let endpoint = environment.campaignUrl + endpoints.creatives.replace('{brandId}', brandId.toString()).replace('/{creativeId}', '');
    return http.post(endpoint, creatives).toPromise().then(
        (response: Array<CreativeData>) => {
            return response;
        }
    );
}

function getCreativeById(http: HttpClient, brandId: number, creativeId: number): Promise<CreativeData> {
    let endpoint = environment.campaignUrl + endpoints.creatives.replace('{brandId}', brandId.toString()).replace('{creativeId}', creativeId.toString());
    return http.get(endpoint).toPromise().then(
        (response: CreativeData) => {
            return response;
        }
    );
}

function updateCreative(http: HttpClient, brandId: number, creative: CreativeData): Promise<any> {
    if (!creative.creative_id) {
        return Promise.reject('Creative ID is required');
    }
    let endpoint = environment.campaignUrl + endpoints.creatives.replace('{brandId}', brandId.toString()).replace('{creativeId}', creative.creative_id.toString());
    return http.put(endpoint, creative).toPromise().then(
        (response: any) => {
            return response;
        }
    );
}

function assignCreativesToCampaign(http: HttpClient, campaignId: number, data: Array<CampaignAssociations>): Promise<any> {
    let endpoint = environment.campaignUrl + endpoints.campaignAssociations.replace('{campaignId}', campaignId.toString());
    return http.put(endpoint, data).toPromise().then(
        (response: any) => {
            return response;
        }
    );
}

function getCampaignCreativeStatus(http: HttpClient, campaignId: number): Promise<CampaignCreativeStatus> {
    let endpoint = environment.campaignUrl + endpoints.campaignCreativeStatus.replace('{campaignId}', campaignId.toString());
    return http.get(endpoint).toPromise().then(
        (response: CampaignCreativeStatus) => {
            return response;
        }
    );
}

function getCampaignCreatives(http: HttpClient, campaignId: number): Promise<Array<CampaignCreativeData>> {
    let endpoint = environment.campaignUrl + endpoints.campaignCreatives.replace('{campaignId}', campaignId.toString());
    return http.get(endpoint).toPromise().then(
        (response: Array<CampaignCreativeData>) => {
            return response;
        }
    );
}

function getCreativesPaymentStatus(http: HttpClient, creativeIds: number[], offset: number = 0, limit: number = -1): Promise<Array<CreativePaymentStatus>> {
    let endpoint = environment.campaignUrl + endpoints.creativePaymentStatus.replace('{entityIds}', creativeIds.join(',')).replace('{offset}', offset.toString()).replace('{limit}', limit.toString());
    return http.get(endpoint).toPromise().then(
        (response: Array<CreativePaymentStatus>) => {
            return response;
        }
    );
}

function getAdsDurations(http: HttpClient, connectionId: number): Promise<Array<AdDurationData>> {
    let endpoint = environment.campaignUrl + endpoints.adDurations.replace('{connectionId}', connectionId.toString());
    return http.get(endpoint).toPromise().then(
        (response: Array<AdDurationData>) => {
            return response;
        }
    );
}